import { Widget, WidgetProps } from "@rjsf/utils";
import React, { useContext, useEffect } from "react";

import { LimitContext } from "../context/LimitContext";
import { WaitlistContext } from "../context/WaitlistContext";

export const WAITLIST_COLOR = "#c2410c";

export const LimitedCheckboxWidget: Widget = (props: WidgetProps) => {
  const limitId = props.label;
  const limits = useContext(LimitContext);
  const limit = limits.filter((limit) => limit.property === limitId).pop();
  const waitlist = useContext(WaitlistContext);
  const bookedOut = limit !== undefined && limit.available <= 0;
  // waitlist entries do not take a place, so booked out offers stay selectable
  const onWaitlist = waitlist.enabled && (waitlist.allToWaitlist || bookedOut);
  const disabled = limit === undefined || (bookedOut && !waitlist.enabled);

  useEffect(() => {
    if (disabled) {
      props.onChange(false);
    }
  }, [props.value, limit, disabled]);

  return (
    <div className={"form-check"}>
      <label className={"control-label"}>
        <input
          className={"limited-checkbox"}
          disabled={disabled}
          type="checkbox"
          checked={props.value ?? false}
          required={props.required}
          onChange={(event) => {
            props.onChange(event.currentTarget.checked);
          }}
        />
        <span>
          <span style={{ display: "inline-block", marginLeft: 5 }} className={"limited-checkbox-label"}>
            {props.label}
          </span>
          {onWaitlist ? (
            <span
              style={{ display: "inline-block", marginLeft: 5, color: WAITLIST_COLOR, fontWeight: 600 }}
              className={"limited-checkbox-waitlist"}>
              (Warteliste)
            </span>
          ) : (
            <span style={{ display: "inline-block", marginLeft: 5 }} className={"limited-checkbox-limit"}>
              ({limit === undefined ? "Freie Plätze werden geladen" : `${limit.available} freie Plätze`})
            </span>
          )}
        </span>
      </label>
    </div>
  );
};
